/**
 * Created by xingxiaowen on 2018/11/01
 */
import Stomp from 'stompjs'
import SockJS from 'sockjs-client'
import { wsUrl } from '@/config/config'
import { getToken } from '@/utils/auth'
const sock = new SockJS(wsUrl)
export const stompClient = Stomp.over(sock)

export function newClient() {
  return Stomp.over(new SockJS(wsUrl))
}

/**
 * websocket封装，实现断线重连和订阅的功能
 * Add by xingxiaowen on 2018/11/20
 * @param options 同settings
 * @constructor
 */
export const WS = function(options) {
  this.settings = {
    url: wsUrl,
    // 订阅集合 key 为主题，value { callback: function }
    subscribes: {},
    timeoutId: null,
    // 连接成功回调
    connectCallback: frame => {},
    // 断开连接回调
    errorCallback: error => {},
    // 是否断开重连
    isReconnect: true,
    // 重连间隔
    reconnectInterval: 5 * 1000,
    reconnectAttempts: 0
  }

  if (!options) { options = {} }

  // Overwrite and define settings with options if they exist.
  for (const key in this.settings) {
    if (typeof options[key] !== 'undefined') {
      this[key] = options[key]
    } else {
      this[key] = this.settings[key]
    }
  }
  this.client = Stomp.over(new SockJS(this.url))
  this.client.debug = null
  this.connected = false
  /**
   * 连接
   * @param connectCallback 连接成功的回调
   * @param errorCallback 连接失败的回调
   */
  this.connect = function(connectCallback, errorCallback) {
    this.connectCallback = connectCallback
    this.errorCallback = errorCallback
    return this.client.connect({ 'Authorization': getToken() }, frame => {
      this.connected = true
      clearTimeout(this.timeoutId)
      if (connectCallback) {
        connectCallback(frame)
      }
      this.initSubscribes()
    }, error => {
      this.connected = false
      this.client.disconnect()
      if (errorCallback) {
        errorCallback(error)
      }
      if (this.isReconnect) {
        this.reconnect()
      }
    })
  }
  /**
   * 订阅
   * @param destination
   * @param callback
   * @param headers
   */
  this.subscribe = function(destination, callback, headers) {
    if (!this.connected) {
      this.subscribes[destination] = {
        'callback': callback,
        'subscribed': false
      }
      return
    }
    // 同一个客户端不重复订阅 alter by xingxiaowen on 2018/11/23
    if (this.subscribes[destination] && this.subscribes[destination]['subscribed']) {
      return
    }
    this.subscribes[destination] = {
      'callback': callback,
      'subscribed': true
    }
    return this.client.subscribe(destination, res => {
      if (callback) {
        callback(res)
      }
    }, headers)
  }
  /**
   * 初始化订阅所有的主题
   */
  this.initSubscribes = function() {
    Object.keys(this.subscribes).forEach(destination => {
      this.subscribe(destination, this.subscribes[destination].callback)
    })
  }

  /**
   * 断线重连
   */
  this.reconnect = function() {
    // 断线清除订阅记录
    Object.keys(this.subscribes).forEach(key => {
      this.subscribes[key]['subscribed'] = false
    })
    clearTimeout(this.timeoutId)
    this.timeoutId = setTimeout(() => {
      this.reconnectAttempts++
      this.client = Stomp.over(new SockJS(this.url))
      this.connect(this.connectCallback, this.errorCallback)
    }, this.reconnectInterval)
  }

  /**
   * 断开连接
   * @param disconnectCallback
   * @param headers
   */
  this.disconnect = function(disconnectCallback, headers) {
    this.isReconnect = false
    this.client.disconnect(res => {
      if (disconnectCallback) {
        disconnectCallback(res)
      }
    }, headers)
  }
}

const client = new WS()
client.connect(res => {}, err => {})
export default client
